// <auto-generated>
// This file is automatically generated from DSL.
// Do not modify this file directly. Changes will be overwritten.
// Generated: 2026-07-02T11:40:08.794Z
// </auto-generated>

import { lazy, Suspense } from 'react';

const InternalPriceListListView = lazy(() => import('@/pricing/InternalPriceListListView').then(m => ({ default: m.InternalPriceListListView })));
const InternalPriceListDetailView = lazy(() => import('@/pricing/InternalPriceListDetailView').then(m => ({ default: m.InternalPriceListDetailView })));
const PriceListListView = lazy(() => import('@/pricing/PriceListListView').then(m => ({ default: m.PriceListListView })));
const PriceListDetailView = lazy(() => import('@/pricing/PriceListDetailView').then(m => ({ default: m.PriceListDetailView })));

/**
 * Pricing Module Routes
 */
export const pricingRoutes = [
{ path: '/pricing/internalpricelists',
element: <Suspense><InternalPriceListListView /></Suspense> },
{ path: '/pricing/internalpricelists/:id',
element: <Suspense><InternalPriceListDetailView /></Suspense> },
{ path: '/pricing/pricelists',
element: <Suspense><PriceListListView /></Suspense> },
{ path: '/pricing/pricelists/:id',
element: <Suspense><PriceListDetailView /></Suspense> }
];
